import { StorkPermissions } from '@quadminds/shared/commons';
import { StorkModules } from '../../enums';

export interface UserPermissionsPresets {
    name: string;
    permissions: StorkPermissions[];
    appModules: StorkModules[];
}
